// Deterministic date/time formatting (no locale/timezone dependence → no hydration drift).
// Dates are yyyy-mm-dd; datetimes are yyyy-mm-ddTHH:mm.

const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export function formatDate(value?: string | null): string {
  if (!value) return "";
  const [y, m, d] = value.split("T")[0].split("-").map(Number);
  if (!y || !m || !d) return value;
  return `${d} ${MONTHS_SHORT[m - 1]} ${y}`;
}

export function formatTime(time?: string): string {
  if (!time) return "";
  const [hh, mm] = time.split(":").map(Number);
  if (Number.isNaN(hh)) return "";
  const ampm = hh < 12 ? "AM" : "PM";
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${h12}:${String(mm ?? 0).padStart(2, "0")} ${ampm}`;
}

export function formatDateTime(value?: string | null): string {
  if (!value) return "";
  const [d, t] = value.split("T");
  return t ? `${formatDate(d)}, ${formatTime(t)}` : formatDate(d);
}

// Parse yyyy-mm-dd[THH:mm] as a LOCAL timestamp (ms), or null.
function parseLocal(value?: string | null): number | null {
  if (!value) return null;
  const [d, t] = value.split("T");
  const [y, mo, da] = d.split("-").map(Number);
  const [hh, mm] = (t ?? "00:00").split(":").map(Number);
  if (!y || !mo || !da) return null;
  return new Date(y, mo - 1, da, hh || 0, mm || 0).getTime();
}

// Short, floored gap from `from` to `to`, e.g. "3h", "2d", "45m". Empty if past/invalid.
export function humanUntil(to?: string | null, from?: string | null): string {
  const a = parseLocal(to);
  const b = parseLocal(from);
  if (a == null || b == null) return "";
  const minutes = Math.floor((a - b) / 60000);
  if (minutes <= 0) return "";
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}
